(function () {
    'use strict';

    // Register all Framework modules here.
    angular.module('inoApp.directives', []);
    angular.module('inoApp.directives.layout', []);

    angular.module('inoApp', [
        // Angular modules 
        'ngAnimate',        // animations
        'ui.router',        // routing and navigation
        'ngSanitize',       // sanitizes html bindings (ex: sidebar.js)

        // SmartAdmin
        'sa.directives',
  	  
        // Custom modules 
        'inoApp.templates',
        'inoApp.directives',
        'inoApp.directives.layout',
        'common',           // common functions, logger
        'common.bootstrap', // bootstrap dialog wrapper functions

        // 3rd Party Modules
        'ui.bootstrap',     // ui-bootstrap (ex: carousel, pagination, dialog)
        'pascalprecht.translate',
        'angularMoment',
        'tmh.dynamicLocale',
        'cgBusy'
    ]);

})();